var React = require('react');

function LockOpen (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2.41667 5.33333H9.58333C9.95152 5.33333 10.25 5.63181 10.25 6V10.3333C10.25 10.7015 9.95152 11 9.58333 11H2.41667C2.04848 11 1.75 10.7015 1.75 10.3333V6C1.75 5.63181 2.04848 5.33333 2.41667 5.33333Z","fill":"#424242","key":0}),React.createElement("path",{"d":"M3.02377 3.26382C3.35832 1.96154 4.54493 1 5.96185 1C7.6278 1 9.00018 2.33133 9.00018 4V6.33333H7.50018V4C7.50018 3.18354 6.82336 2.5 5.96185 2.5C5.23919 2.5 4.64318 2.98859 4.47659 3.63705C4.37353 4.03824 3.96475 4.27991 3.56357 4.17685C3.16238 4.07379 2.9207 3.66501 3.02377 3.26382Z","fill":"#424242","key":1})]);
}

LockOpen.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = LockOpen;

LockOpen.default = LockOpen;
